import * as AlertDialogPrimitive from '@radix-ui/react-alert-dialog';

interface ClosePersonalisationModalProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  onCloseAutoFocus?: (event: Event) => void;
}

export default function ClosePersonalisationModal({
  open,
  onCancel,
  onConfirm,
  onCloseAutoFocus,
}: ClosePersonalisationModalProps) {
  return (
    <AlertDialogPrimitive.Root open={open}>
      <AlertDialogPrimitive.Portal>
        <AlertDialogPrimitive.Overlay className="fixed inset-0 z-[110] bg-black/40 backdrop-blur-[2px]" />

        <AlertDialogPrimitive.Content
          onCloseAutoFocus={onCloseAutoFocus}
          className="pointer-events-auto fixed left-1/2 top-1/2 z-[111] max-h-[calc(100dvh_-_32px)] w-[calc(100%_-_32px)] max-w-[540px] -translate-x-1/2 -translate-y-1/2 overflow-y-auto overscroll-contain border border-border bg-background px-[22px] py-[26px] shadow-[0_18px_50px_rgba(10,10,10,0.22)] outline-none sm:px-[38px] sm:py-[34px]"
        >
          <header className="text-center">
            <AlertDialogPrimitive.Title className="mt-[8px] text-[28px] font-bold leading-[33px] sm:text-[32px] sm:leading-[37px]">
              Are you sure?
            </AlertDialogPrimitive.Title>
          </header>

          <div className="my-[22px] border-t border-dashed border-[#e5e5e5]" />

          <AlertDialogPrimitive.Description asChild>
            <div className="font-[Arial] font-normal text-[clamp(17px,1.5vw,18px)] leading-relaxed">
              <p className="mb-[12px]">
                If you choose to discard your changes, all your unsaved work will be{' '}
                <b className="text-red-600">permanently lost.</b>
              </p>

              <p>
                This action <b>cannot be undone</b>. Select <b>Keep editing</b> to return to the editor and preserve
                your changes.
              </p>
            </div>
          </AlertDialogPrimitive.Description>

          <div className="mt-[28px] flex flex-row gap-[12px] sm:items-center sm:justify-between sm:gap-[20px]">
            <AlertDialogPrimitive.Action asChild>
              <button
                className="button-screwfix-danger flex h-[48px] w-full flex-1 items-center justify-center gap-[9px] !px-[22px] [font-family:archivo_narrowbold,sans-serif] !text-[clamp(18px,calc(16px_+_0.3vw),19px)] font-bold focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring/35 disabled:pointer-events-none disabled:opacity-60 sm:min-w-[190px] sm:w-auto"
                onClick={onConfirm}
                type="button"
              >
                Discard changes
              </button>
            </AlertDialogPrimitive.Action>

            <AlertDialogPrimitive.Cancel asChild>
              <button
                className="button-screwfix-secondary flex h-[48px] w-full flex-1 items-center justify-center !px-[22px] [font-family:archivo_narrowbold,sans-serif] !text-[clamp(18px,calc(16px_+_0.3vw),19px)] font-bold focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring/30 disabled:pointer-events-none disabled:opacity-60 sm:min-w-[150px] sm:w-auto"
                onClick={onCancel}
                type="button"
              >
                Keep editing
              </button>
            </AlertDialogPrimitive.Cancel>
          </div>
        </AlertDialogPrimitive.Content>
      </AlertDialogPrimitive.Portal>
    </AlertDialogPrimitive.Root>
  );
}
